export const BRAND_LOCALES = ['fr', 'en', 'ar', 'es'] as const;

export type BrandLocale = (typeof BRAND_LOCALES)[number];

export interface LocalizedContactFields {
  address?: string;
  phone?: string;
  email?: string;
  whatsapp?: string;
}

export type LocalizedContact = Partial<Record<BrandLocale, LocalizedContactFields>>;

export interface PublicBrand {
  name: string;
  shortName: string;
  city: string;
  address: string;
  phone: string;
  whatsapp: string;
  email: string;
  logoUrl: string;
  localizedContact: LocalizedContact;
}

export interface ResolvedContact {
  name: string;
  shortName: string;
  city: string;
  address: string;
  phone: string;
  whatsapp: string;
  email: string;
  logoUrl: string;
}

export const FALLBACK_BRAND: PublicBrand = {
  name: 'fleetava',
  shortName: 'fleetava',
  city: '',
  address: '',
  phone: '',
  whatsapp: '',
  email: '',
  logoUrl: '',
  localizedContact: {},
};

export function isLocalizedContact(value: unknown): value is LocalizedContact {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return false;
  return true;
}

export function isBrandLocale(value: string): value is BrandLocale {
  return value === 'fr' || value === 'en' || value === 'ar' || value === 'es';
}

export function brandForLocale(brand: PublicBrand, locale: string): ResolvedContact {
  const localized = isBrandLocale(locale) ? brand.localizedContact[locale] : undefined;
  return {
    name: brand.name,
    shortName: brand.shortName,
    city: brand.city,
    logoUrl: brand.logoUrl,
    address: localized?.address || brand.address,
    phone: localized?.phone || brand.phone,
    email: localized?.email || brand.email,
    whatsapp: localized?.whatsapp || brand.whatsapp,
  };
}

const HEX_COLOR = /^#[0-9A-Fa-f]{6}$/;

export function cssColor(value: string | null | undefined, fallback: string): string {
  if (value && HEX_COLOR.test(value)) return value;
  return fallback;
}

export function safeAssetUrl(value: string | null | undefined): string {
  const trimmed = (value ?? '').trim();
  if (!trimmed) return '';
  if (trimmed.startsWith('/') && !trimmed.startsWith('//')) return trimmed;
  try {
    const url = new URL(trimmed);
    if (url.protocol === 'https:' || url.protocol === 'http:') return url.toString();
  } catch {
    return '';
  }
  return '';
}
